import { omit } from "lodash";
import { FETCH_JOBS, REMOVE_JOB } from "actions";

const INITIAL_STATE = {};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case FETCH_JOBS:
      // Replace, don't merge: the payload is the full snapshot of the active
      // jobs query, and merging left jobs from a previous query (e.g. closed
      // ones) in the store forever.
      return action.payload || {};
    case REMOVE_JOB:
      return omit(state, action.payload);
    default:
      return state;
  }
}
